// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const Container = styled.div`
    margin-top: 48px;
    max-width: calc((100vw - 192px) / 2);
    max-height: calc(100vh - 48px);
    background: #fff;
    overflow-y: auto;
    flex-basis: 0;
    flex-grow: 5;
    padding-bottom: 1rem;
    position: relative;
`;